export enum CiecStatus {
    PENDING,
    VALID,
    REJECTED,
    ERROR
}
